module.exports = __webpack_public_path__ + "img/codensa.ff33834f.svg";